(function(){
  var ctx=window.LUX_PDP||{};
  var variants=ctx.variants||[];
  var currency=ctx.currency||'EUR';
  var inv=window.LUX_PDP_INV||{};
  var sellingPlans=window.LUX_PDP_SELLING_PLANS||{};
  var lowThreshold=window.LUX_PDP_LOW||10;
  var stockOn=window.LUX_PDP_STOCK_ON!==false;
  var groups=document.querySelectorAll('.lux-pdp-option');
  var vid=document.getElementById('lux-vid');
  var cta=document.getElementById('lux-cta');
  var notifyBtn=document.getElementById('BIS_trigger')||document.getElementById('lux-cta-notify');
  var qtyWrap=document.getElementById('lux-qty-wrap');
  var priceEl=document.getElementById('lux-price');
  var mainImg=document.getElementById('lux-main-img');
  var skuEl=document.getElementById('lux-sku');
  var saleBadge=document.getElementById('lux-pdp-sale');
  var stockEl=document.getElementById('lux-stock');
  var stockText=stockEl?stockEl.querySelector('.lux-pdp-stock-text'):null;
  var productForm=document.getElementById('lux-form');
  var mobileAtc=document.getElementById('lux-mobile-atc');
  var mobileAtcButton=document.getElementById('lux-mobile-atc-button');
  var mobileAtcPrice=document.getElementById('lux-mobile-atc-price');
  var purchaseRow=document.getElementById('lux-purchase-row');
  var qtyInput=document.getElementById('lux-qty');
  var sellingPlanInput=document.getElementById('lux-selling-plan');
  var avPanel=document.getElementById('lux-av-panel');
  var avLabelText=document.getElementById('lux-av-label-text');
  var avNote=document.getElementById('lux-av-note');
  var avStock=document.getElementById('lux-av-stock');
  var avStockIncoming=document.getElementById('lux-av-stock-incoming');
  var avStockReserved=document.getElementById('lux-av-stock-reserved');
  var avStockAvail=document.getElementById('lux-av-stock-avail');
  var avUrgency=document.getElementById('lux-av-urgency');
  var avReservedNote=document.getElementById('lux-av-reserved-note');
  var stateMap=(function(){
function syncTimesactAllocation(){
  var data=window.TimesactData;
  var product=data&&data.product;
  if(!product||!Array.isArray(product.variants)||!product.variants.length)return;
  var selected=document.querySelector('form[action*="/cart/add"] [name="id"]');
  var selectedId=String((selected&&selected.value)||(product.variants[0]&&product.variants[0].id)||'');
  var variant=product.variants.find(function(item){return String(item.id)===selectedId;})||product.variants[0];
  var states=Object.values((variant&&variant.experiencesState)||{});
  var allocation=states.find(function(item){return item&&item.preOrderStatus==='ACTIVE';});
  if(!allocation)return;
  var total=Number(allocation.preOrderQuantity)||0;
  var sold=Number(allocation.preOrderQuantitySold)||0;
  if(total<1)return;
  var remaining=Math.max(0,total-sold);
  var stock=document.getElementById('lux-av-stock');
  var incoming=document.getElementById('lux-av-stock-incoming');
  var reserved=document.getElementById('lux-av-stock-reserved');
  var available=document.getElementById('lux-av-stock-avail');
  var urgency=document.getElementById('lux-av-urgency');
  var reservedNote=document.getElementById('lux-av-reserved-note');
  var label=document.getElementById('lux-av-label-text');
  var purchase=document.getElementById('lux-purchase-row');
  if(stock)stock.hidden=false;
  if(incoming)incoming.hidden=true;
  if(reserved){reserved.textContent=sold+' reserved';reserved.hidden=sold<1;}
  if(available)available.textContent=remaining+' available to reserve';
  if(urgency)urgency.hidden=true;
  if(reservedNote)reservedNote.hidden=remaining>0;
  if(label)label.textContent=remaining>0?'Pre-order':'Fully reserved';
  var quantityInput=document.querySelector('input[name="quantity"]');
  if(quantityInput){
    quantityInput.max=String(remaining);
    if(Number(quantityInput.value)>remaining)quantityInput.value=String(remaining);
  }
  var increaseButton=document.querySelector('button[aria-label="Increase quantity"]');
  if(increaseButton)increaseButton.disabled=!quantityInput||Number(quantityInput.value)>=remaining;
  if(purchase)purchase.style.setProperty('display',remaining>0?'grid':'none','important');
  Array.prototype.forEach.call(document.querySelectorAll('button'),function(button){
    if(button.textContent.trim()==='Notify me when available')button.style.display=remaining>0?'none':'';
  });
}
[0,250,750,1500,3000,6000].forEach(function(delay){setTimeout(syncTimesactAllocation,delay);});
document.addEventListener('change',function(){setTimeout(syncTimesactAllocation,80);});
return window.LUX_PDP_STATE;
})()||{};

  // Availability is resolved in Liquid by snippets/luxonas-availability.liquid
  // and passed through per variant, so the client never re-decides the state.
  function availabilityFor(id){
    var parts=String(stateMap[id]||'').split('|');
    return {
      state:parts[0]||'',
      month:parts[1]||'',
      arrival:parts[2]||'',
      // Fields 3-7 carry the incoming allocation. Older cached markup has
      // only three fields, so every one of these falls back safely to 0/''.
      incoming:parseInt(parts[3],10)||0,
      reserved:parseInt(parts[4],10)||0,
      remaining:parseInt(parts[5],10)||0,
      allocated:parts[6]==='1',
      full:parts[7]==='1'
    };
  }
  function ctaLabelFor(a){return a.state==='pre-order'?'Reserve yours':'Add to cart';}

  // The pre-order app rewrites the main button's wording on its own products.
  // Mirroring it keeps the sticky bar saying exactly what the buy button says.
  function syncStickyLabel(){
    if(!mobileAtcButton||!cta)return;
    if(mobileAtcButton.dataset.available==='false')return;
    var label=(cta.textContent||'').trim();
    if(label&&mobileAtcButton.textContent.trim()!==label)mobileAtcButton.textContent=label;
  }
  function renderAvailability(a){
    if(!avPanel)return;
    avPanel.className='lux-av-panel lux-av-panel--'+(a.state||'unavailable');
    avPanel.setAttribute('data-state',a.state||'');
    var label='Sold out';
    var note='';
    var when=a.arrival||a.month;
    if(a.state==='in-stock'){label='In stock in Malta';note='Ready for delivery';}
    else if(a.state==='pre-order'){label='Pre-order';note=when?'Expected arrival '+when:'';}
    else if(a.state==='coming-soon'){label='Coming soon';note=when?'Arriving '+when:'';}
    if(a.full)label='Fully reserved';
    if(avLabelText)avLabelText.textContent=label;
    if(avNote){avNote.textContent=note;avNote.hidden=!note;}
    renderAllocation(a);
  }

  // The incoming allocation, kept in step when the customer switches variant.
  function renderAllocation(a){
    if(avStock){
      avStock.hidden=!a.allocated;
      if(a.allocated){
        if(avStockIncoming)avStockIncoming.textContent=a.incoming+(a.incoming===1?' unit arriving':' units arriving');
        if(avStockReserved){
          avStockReserved.textContent=a.reserved+' reserved';
          avStockReserved.hidden=a.reserved<1;
        }
        if(avStockAvail){
          avStockAvail.textContent=a.remaining+' available to reserve';
          avStockAvail.classList.toggle('is-zero',a.full);
        }
      }
    }
    if(avUrgency){
      // Quiet until units have actually gone: never scarcity on an untouched order.
      var showUrgency=a.allocated&&!a.full&&a.remaining<=5&&a.remaining<a.incoming;
      avUrgency.textContent='Only '+a.remaining+' left to pre-order';
      avUrgency.hidden=!showUrgency;
    }
    if(avReservedNote)avReservedNote.hidden=!a.full;
  }

  function fmt(c){try{return new Intl.NumberFormat('en-US',{style:'currency',currency:currency}).format(c/100);}catch(e){return '€ '+(c/100).toFixed(2);}}

  function update(){
    var vals=[];
    groups.forEach(function(g){var s=g.querySelector('.lux-pdp-btn.selected');vals.push(s?s.dataset.value:null);});
    var v=variants.find(function(x){return vals.every(function(val,i){return x['option'+(i+1)]===val;});});
    if(!v)return;
    if(vid)vid.value=v.id;
    if(sellingPlanInput){
      var sellingPlanId=sellingPlans[v.id];
      if(sellingPlanId){
        sellingPlanInput.value=sellingPlanId;
        sellingPlanInput.disabled=false;
      }else{
        sellingPlanInput.value='';
        sellingPlanInput.disabled=true;
      }
    }
    var availability=availabilityFor(v.id);
    renderAvailability(availability);
    if(cta)cta.textContent=ctaLabelFor(availability);
    if(priceEl){priceEl.innerHTML=(v.compare_at_price&&v.compare_at_price>v.price?'<s>'+fmt(v.compare_at_price)+'</s> ':'')+fmt(v.price);}
    // A spent allocation closes the purchase area even where Shopify would
    // still sell, so the page can never take a pre-order it cannot honour.
    var canBuy=v.available&&!availability.full;
    if(cta)cta.style.display=canBuy?'':'none';
    if(qtyWrap)qtyWrap.style.display=canBuy?'':'none';
    if(purchaseRow)purchaseRow.style.display=canBuy?'':'none';
    if(mobileAtcButton){
      mobileAtcButton.disabled=false;
      mobileAtcButton.dataset.available=canBuy?'true':'false';
      mobileAtcButton.textContent=canBuy?ctaLabelFor(availability):'Notify me';
    }
    syncStickyLabel();
    if(mobileAtcPrice)mobileAtcPrice.textContent=fmt(v.price);
    if(notifyBtn){
      notifyBtn.style.display=canBuy?'none':'';
      notifyBtn.setAttribute('data-variant-id',v.id);
    }
    if(skuEl&&v.sku){skuEl.innerHTML='<b>SKU</b> '+v.sku;}
    if(saleBadge){saleBadge.hidden=!(v.compare_at_price&&v.compare_at_price>v.price);}
    if(stockEl&&stockOn){
      var d=inv[v.id];
      if(d&&d.m==='shopify'&&d.a&&d.q>0&&d.q<=lowThreshold){
        if(stockText)stockText.textContent=d.q+' left';
        stockEl.style.display='';
      }else{
        stockEl.style.display='none';
      }
    }
    groups.forEach(function(g,i){var l=g.querySelector('.selval');if(l)l.textContent=vals[i];});
  }

  groups.forEach(function(g){
    g.querySelectorAll('.lux-pdp-btn').forEach(function(b){
      b.addEventListener('click',function(){
        g.querySelectorAll('.lux-pdp-btn').forEach(function(x){x.classList.remove('selected');});
        b.classList.add('selected');
        update();
      });
    });
  });

  document.querySelectorAll('.lux-pdp-thumb').forEach(function(t){
    t.addEventListener('click',function(){
      document.querySelectorAll('.lux-pdp-thumb').forEach(function(x){
        x.classList.remove('active');
        x.setAttribute('aria-pressed','false');
      });
      t.classList.add('active');
      t.setAttribute('aria-pressed','true');
      if(mainImg){
        // The initial Shopify image includes a responsive srcset. If it remains
        // attached, the browser can keep rendering the first image even after
        // src changes, making the thumbnail gallery appear stuck.
        mainImg.removeAttribute('srcset');
        mainImg.src=t.dataset.src;
      }
    });
  });

  function pdfLoadLib(){return new Promise(function(resolve,reject){if(window.jspdf&&window.jspdf.jsPDF)return resolve();var s=document.createElement('script');s.src='https://cdnjs.cloudflare.com/ajax/libs/jspdf/2.5.1/jspdf.umd.min.js';s.onload=function(){resolve();};s.onerror=reject;document.head.appendChild(s);});}
  function pdfLoadImage(url,preserveTransparency){return new Promise(function(resolve){if(!url)return resolve(null);var img=new Image();img.crossOrigin='anonymous';img.onload=function(){var c=document.createElement('canvas');c.width=img.naturalWidth;c.height=img.naturalHeight;var x=c.getContext('2d');if(!preserveTransparency){x.fillStyle='#ffffff';x.fillRect(0,0,c.width,c.height);}x.drawImage(img,0,0);try{resolve(c.toDataURL(preserveTransparency?'image/png':'image/jpeg',preserveTransparency?undefined:0.92));}catch(e){resolve(null);}};img.onerror=function(){resolve(null);};img.src=url;});}
  function pdfReadData(){
    var d=Object.assign({},window.LUX_PDF_DATA||{});
    var dEl=document.getElementById('lux-dim');
    if(dEl&&dEl.textContent.trim())d.dimensions=dEl.textContent.trim();
    var sEl=document.getElementById('lux-sku');
    if(sEl){var t=sEl.textContent.replace(/^\s*SKU\s*/i,'').trim();if(t)d.sku=t;}
    var pEl=document.getElementById('lux-price');
    if(pEl){var cl=pEl.cloneNode(true);var s=cl.querySelector('s');if(s)s.remove();d.price=cl.textContent.trim();}
    d.specs=[];
    var specsEl=document.getElementById('lux-specs');
    if(specsEl){
      var dts=specsEl.querySelectorAll('dt');
      var dds=specsEl.querySelectorAll('dd');
      dts.forEach(function(dt,i){
        if(!dds[i])return;
        var key=(dt.textContent||'').trim();
        var val=(dds[i].textContent||'').trim();
        if(!key||!val)return;
        if(key.toLowerCase()==='brand')return;
        d.specs.push({label:key,value:val});
      });
    }
    return d;
  }
  function pdfGenerate(btn){
    var d=pdfReadData();
    var label=btn.querySelector('.lux-pdf-btn-label');
    var origText=label?label.textContent:'';
    btn.disabled=true;
    if(label)label.textContent='Preparing PDF...';
    Promise.all([pdfLoadLib(),pdfLoadImage(d.image,false),pdfLoadImage(d.logo,true)]).then(function(r){
      var imgData=r[1];
      var logoData=r[2];
      var jsPDF=window.jspdf.jsPDF;
      var doc=new jsPDF({unit:'mm',format:'a4'});

      // HEADER
      doc.setFillColor(247,244,239);doc.rect(0,0,210,43,'F');
      if(logoData){
        try{doc.addImage(logoData,'PNG',72,8,66,20);}catch(e){}
      }else{
        doc.setFont('helvetica','normal');doc.setFontSize(17);doc.setTextColor(23,20,17);
        doc.text('LUXONAS',105,21,{align:'center'});
      }
      doc.setFont('helvetica','normal');doc.setFontSize(7);doc.setTextColor(142,113,88);
      doc.text('PRODUCT SPECIFICATION',105,35,{align:'center'});
      doc.setDrawColor(142,113,88);doc.setLineWidth(0.35);doc.line(88,39,122,39);

      // IMAGE (left)
      var imgY=54;
      doc.setFillColor(250,248,245);doc.roundedRect(16,imgY-4,83,83,1.5,1.5,'F');
      if(imgData){try{doc.addImage(imgData,'JPEG',20,imgY,75,75);}catch(e){}}

      // RIGHT COLUMN (vendor, title, sku, dimensions, price)
      var x=105,y=imgY+5;
      if(d.vendor){doc.setFont('helvetica','normal');doc.setFontSize(7);doc.setTextColor(142,113,88);doc.text(d.vendor.toUpperCase(),x,y);y+=8;}
      if(d.title){doc.setFont('times','normal');doc.setFontSize(16);doc.setTextColor(23,20,17);var lines=doc.splitTextToSize(d.title,88);doc.text(lines,x,y);y+=lines.length*6.5+5;}
      if(d.sku){doc.setFont('helvetica','normal');doc.setFontSize(7);doc.setTextColor(117,109,101);doc.text('SKU  '+d.sku,x,y);y+=9;}
      if(d.dimensions){doc.setFontSize(7);doc.setTextColor(142,113,88);doc.text('DIMENSIONS',x,y);y+=5;doc.setFontSize(10);doc.setTextColor(23,20,17);doc.text(doc.splitTextToSize(d.dimensions,86),x,y);y+=12;}
      if(d.price){doc.setDrawColor(222,214,205);doc.setLineWidth(0.2);doc.line(x,y-4,194,y-4);doc.setFont('times','normal');doc.setFontSize(16);doc.setTextColor(23,20,17);doc.text(d.price,x,y+3);y+=13;}

      // SPECIFICATIONS SECTION (below image + right col)
      if(d.specs&&d.specs.length){
        var specsY=Math.max(y+6,imgY+75+18);
        // Section header
        doc.setFont('helvetica','normal');doc.setFontSize(7);doc.setTextColor(142,113,88);
        doc.text('DIMENSIONS & MATERIALS',20,specsY);
        doc.setDrawColor(142,113,88);doc.setLineWidth(0.25);doc.line(20,specsY+2,64,specsY+2);
        specsY+=9;

        // Spec rows (label left, value right)
        d.specs.forEach(function(spec,index){
          if(specsY>268)return; // don't overflow into footer
          if(index%2===0){doc.setFillColor(250,248,245);doc.rect(18,specsY-4,176,8,'F');}
          // Label
          doc.setFont('helvetica','bold');doc.setFontSize(7);doc.setTextColor(142,113,88);
          doc.text(spec.label.toUpperCase(),20,specsY);
          // Value
          doc.setFont('helvetica','normal');doc.setFontSize(9);doc.setTextColor(23,20,17);
          var valLines=doc.splitTextToSize(spec.value,130);
          doc.text(valLines,55,specsY);
          specsY+=Math.max(8,valLines.length*5.5);
        });
      }

      // FOOTER
      doc.setFillColor(90,70,56);doc.rect(0,279,210,18,'F');
      doc.setFont('helvetica','bold');doc.setFontSize(6.5);doc.setTextColor(247,244,239);
      doc.text('LUXONAS.COM  |  INFO@LUXONAS.COM  |  ZEBBUG, MALTA',105,287,{align:'center'});
      doc.setFont('helvetica','normal');doc.setFontSize(5.5);doc.setTextColor(213,195,180);
      doc.text('CURATED FOR BEAUTIFUL LIVING',105,292,{align:'center'});

      doc.save((d.handle||'product')+'-specifications.pdf');
    }).catch(function(e){console.error(e);alert('Could not generate PDF.');})
      .then(function(){btn.disabled=false;if(label)label.textContent=origText||'Download PDF Specifications';});
  }
  var pdfBtn=document.querySelector('[data-pdf-download]');
  if(pdfBtn)pdfBtn.addEventListener('click',function(){pdfGenerate(pdfBtn);});

  document.querySelectorAll('.lux-details-toggle').forEach(function(detailsToggle){
    var targetId=detailsToggle.getAttribute('aria-controls');
    var detailsBody=targetId?document.getElementById(targetId):null;
    if(!detailsBody)return;
    detailsToggle.addEventListener('click',function(){
      var isOpen=detailsBody.classList.toggle('open');
      detailsToggle.setAttribute('aria-expanded',String(isOpen));
      var icon=detailsToggle.querySelector('.lux-details-icon');
      if(icon)icon.textContent=isOpen?'−':'+';
    });
  });

  document.querySelectorAll('[data-qty-change]').forEach(function(button){
    button.addEventListener('click',function(){
      if(!qtyInput)return;
      var delta=parseInt(button.getAttribute('data-qty-change'),10)||0;
      var current=parseInt(qtyInput.value,10)||1;
      qtyInput.value=Math.max(parseInt(qtyInput.min,10)||1,current+delta);
      qtyInput.dispatchEvent(new Event('change',{bubbles:true}));
    });
  });

  var zoomButton=document.getElementById('lux-pdp-zoom');
  var lightbox=document.getElementById('lux-pdp-lightbox');
  var lightboxImage=lightbox?lightbox.querySelector('img'):null;
  var lightboxClose=lightbox?lightbox.querySelector('.lux-pdp-lightbox-close'):null;
  function closeLightbox(){
    if(!lightbox)return;
    lightbox.hidden=true;
    document.documentElement.classList.remove('lux-lightbox-open');
    if(zoomButton)zoomButton.focus();
  }
  if(zoomButton&&lightbox){
    zoomButton.addEventListener('click',function(){
      if(lightboxImage&&mainImg)lightboxImage.src=mainImg.currentSrc||mainImg.src;
      lightbox.hidden=false;
      document.documentElement.classList.add('lux-lightbox-open');
      if(lightboxClose)lightboxClose.focus();
    });
    if(lightboxClose)lightboxClose.addEventListener('click',closeLightbox);
    lightbox.addEventListener('click',function(event){if(event.target===lightbox)closeLightbox();});
    document.addEventListener('keydown',function(event){if(event.key==='Escape'&&!lightbox.hidden)closeLightbox();});
  }

  if(mobileAtc&&mobileAtcButton&&cta&&productForm){
    mobileAtcButton.addEventListener('click',function(){
      if(mobileAtcButton.dataset.available==='false'){
        if(notifyBtn)notifyBtn.click();
        return;
      }
      if(mobileAtcButton.disabled)return;
      if(typeof productForm.requestSubmit==='function')productForm.requestSubmit();
      else productForm.submit();
    });

    var cartDrawer=document.getElementById('lux-cd');
    var stickyWanted=false;

    syncStickyLabel();
    if('MutationObserver' in window){
      new MutationObserver(syncStickyLabel).observe(cta,{childList:true,characterData:true,subtree:true});
    }

    function applySticky(){
      var drawerOpen=cartDrawer?cartDrawer.classList.contains('is-open'):false;
      var show=stickyWanted&&!drawerOpen;
      mobileAtc.classList.toggle('is-visible',show);
      mobileAtc.setAttribute('aria-hidden',String(!show));
      document.documentElement.classList.toggle('lux-sticky-on',show);
    }

    if('IntersectionObserver' in window){
      var observer=new IntersectionObserver(function(entries){
        entries.forEach(function(entry){
          stickyWanted=!entry.isIntersecting && cta.style.display!=='none';
          applySticky();
        });
      },{threshold:0});
      observer.observe(cta);
    }

    // The cart drawer owns the screen while it is open.
    if(cartDrawer&&'MutationObserver' in window){
      new MutationObserver(applySticky).observe(cartDrawer,{attributes:true,attributeFilter:['class']});
    }
  }
})();
